import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useApi from "../../hooks/useApi";

import PasswordInput from "../../Components/PasswordInput";
import MainHeader from "../../Components/MainHeader/MainHeader";
import CustomButton from "../../Components/CustomButton";
import ModalWarning from "../../Components/ModalWarning/ModalWarning";
import LangSwitcher from "../../Components/LangSwitcher";

import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";
import { ReactComponent as Exclamation } from "../../static/images/exclamation_sign.svg";

import "./style.scss";

const ResetPasswordLink = () => {
  const [resetPassword, setResetPassword] = useState("");

  const [warningModalToggle, setWarningModalToggle] = useState("");
  const [warningModalText, setWarningModalText] = useState("");
  const [warningButtonText, setWarningButtonText] = useState("");

  const [resetPasswordValidation, setResetPasswordValidation] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);

  const { post } = useApi();

  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (resetPassword === "") {
      setResetPasswordValidation(t("error_fill_password"));
      return;
    }

    if (resetPassword.length < 8) {
      setResetPasswordValidation(t("error_password_length"));
      return;
    }

    try {
      const data = await post("/User/reset-password-confirmation", {
        id: queryParams.user,
        password: resetPassword,
        token: queryParams.token,
      });

      if (data.succeeded === true) {
        setWarningModalToggle("modal-warning");
        setWarningModalText(t("password_reset_success"));
        setWarningButtonText({
          text: t("go_login_page"),
          func: () => {
            navigate("/");
          },
        });
      } else {
        setWarningModalToggle("modal-warning");
        setWarningModalText(data.errors[0].description);
        setWarningButtonText({ text: t("close"), func: () => {} });
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (ps10005000 && pathname === "/") {
      navigate("sessions");
      return;
    }
  }, [ps10005000, navigate]);

  return (
    <>
      <ModalWarning
        warningText={warningModalText}
        changeModal={setWarningModalToggle}
        modalValue={warningModalToggle}
        buttonText={warningButtonText.text}
        Image={warningButtonText.text === t("close") ? Exclamation : Tick}
        handleButton={warningButtonText.func}
      />

      <MainHeader />

      <div className="reset-password-link">
        <div className="reset-password-link-header">
          <h3>{t("password_create")}</h3>
        </div>
        <div className="reset-text">
          <span>{t("password_recomendations")}</span>
        </div>
        <form
          onSubmit={(e) => {
            handleResetPassword(e);
          }}
          className="reset-password-link-form"
        >
          <PasswordInput
            name="register-password"
            label={t("input_label_new_password")}
            size="medium"
            value={resetPassword}
            onChange={(e) => setResetPassword(e.target.value)}
            required
          />

          <CustomButton fullWidth type="submit" fontSize="1.2rem">
            {t("reset_password")}
          </CustomButton>

          <CustomButton
            fullWidth
            fontSize="1.2rem"
            color="primary"
            onClick={() => {
              navigate("/");
            }}
          >
            {t("go_login_page")}
          </CustomButton>

          <h3>{resetPasswordValidation}</h3>
        </form>

        <div className="main-pages-langswitcher">
          <LangSwitcher />
        </div>
      </div>
    </>
  );
};

export default ResetPasswordLink;
